<template style="height:100%">
  <div id="Activity_released" class="Activity_released">
    <el-tabs v-model="activeName">
      <el-tab-pane label="组织活动" name="first" style="height:100%;">
        <Notest />
      </el-tab-pane>
      <el-tab-pane label="自助活动" name="second">
        <Alreadytest />
      </el-tab-pane>
    </el-tabs>
  </div>
</template>
<script>
import Notest from './Activity_offline'
import Alreadytest from './Activity_selfhelp'
  export default {
    data() {
      return {
        activeName: 'first',
        isActive: true,
        activeClass: 'Nac',
        errorClass: 'Nac2',
        checkboxGroup1: [],
      };
    },
    components:{
      Notest,
      Alreadytest,
    },
    methods: {
      handleChange(val) {
      },
      change(){
        this.isActive = !this.isActive;
      },
      onSubmit(){
      },
      handleEdit(index, row) {
      },
      handleDelete(index, row) {
      }
    }
  };
</script>
<style>
.Activity_released{background-color: #fff;overflow: auto;}
.Activity_released .el-tabs__nav{margin-left: 16px !important;}
</style>
